import { ApiModel } from "./api-model";
import {
  ProgramArticleTranslation,
  ProgramArticleTranslationETT,
} from "./program-article-translation";
import { Value } from "./value";

export class EventArticle extends ApiModel {
  id: number;
  sportingEventId: number;
  name: string;
  startDate: string;
  endDate: string;
  isContribued: boolean;
  // Language
  language: Value;
  availableLanguages: number[];
  translations: ProgramArticleTranslation[];
  translationsETT: ProgramArticleTranslationETT[];

  /**
   * Remove picture raw data to avoid heavy request
   */
  cleanPicture(blob: boolean) {
    if (this.translations && this.translations.length > 0) {
      this.translations = this.translations.map((t) => {
        if (t.value["picture"]) {
          const formats = [
            "original",
            "format_16_9",
            "format_4_3",
            "format_3_4",
          ];
          formats.forEach((format) => {
            if (t.value.picture[format]) {
              t.value.picture[format].displayUrl = null;
              if (blob && t.value.picture[format].blob) {
                t.value.picture[format].blob = null;
              }
            }
          });
        }
        return t;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/event-article.ts